import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import i18n from 'i18next'

import { getBackendLanguage } from '../utils/language'

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_IP}/`,
  prepareHeaders: (headers) => {
    headers.set('Accept-Language', getBackendLanguage(i18n))

    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      const user = JSON.parse(storedUser)
      if (user?.token) {
        headers.set('Authorization', `Bearer ${user.token}`)
      }
    }
    return headers
  },
})

// Define an API slice--
export const api = createApi({
  tagTypes: [
    'Stamps',
    'Logs',
    'Categories',
    'Files',
    'Documents',
    'Protocol',
    'PlaceOfExpanse',
    'Companies',
    'Attachments',
    'DocumentRelations',
    'Companies',
    'Alerts',
    'Email',
    'Groups',
    'Configurator',
    'Users',
    'Logs',
    'Function',
    'AwaitingDocs',
    'Status',
    'Partners',
    'CategoryAccessPolicies',
    'ReturnReceipt',
    'HelpDesk',
    'HelpDeskEmailSettings',
    'HelpdeskNotifications',
  ],
  baseQuery,
  endpoints: (builder) => ({}),
})
